// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import { db } from '@/shared/firebase/firebase-init';

export default {
  list(id) {
    return new Promise((resolve) => {
      db.ref("log")
        .child("logs")
        .child("players")
        .orderByChild("id")
        .equalTo(id)
        .once('value').then((snapshot) => { 
        var list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });

        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/player/player-history/player-history-single/player-history-single-service.js